var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17561",
    "data-name": "Group 17561",
    transform: "translate(-921 -549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(925 553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17443",
    "data-name": "Group 17443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8354",
    "data-name": "Path 8354",
    d: "M19.822,4.647l-.183.058-.975.087-.275.44-.2-.063-.776-.7L17.3,4.106l-.151-.388-.487-.437-.575-.113-.013.263.563.55.276.325-.31.162-.252-.074-.378-.158.013-.3-.5-.2-.165.717-.5.113.049.4.651.125.113-.639.538.079.25.146h.4l.274.55.728.738-.053.287-.587-.075-1.014.512-.73.876-.095.388h-.262L14.6,7.719l-.474.225.118.5.206-.238.363-.011-.025.449.3.088.3.337.49-.138.56.088.65.175.325.038.551.625,1.063.625L18.34,11.8l-.725.337-.275.75-1.05.7-.112.4a6.108,6.108,0,0,0,3.644-9.341Z",
    transform: "translate(-8.628 -1.935)",
    fill: "#c22127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8355",
    "data-name": "Path 8355",
    d: "M6.822,13.911l-.445-.826.409-.852-.409-.122-.459-.461L4.9,11.422l-.338-.706v.419H4.414L3.538,9.947V8.971L2.9,7.926l-1.02.182H1.188L.842,7.882l.441-.35-.44.1a6.107,6.107,0,0,0,5.275,9.2,6.4,6.4,0,0,0,.767-.053l-.064-.741s.281-1.1.281-1.138S6.822,13.911,6.822,13.911Z",
    transform: "translate(-0.004 -4.6)",
    fill: "#c22127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8356",
    "data-name": "Path 8356",
    d: "M4.47,1.972l1.086-.151.5-.274.563.162.9-.05.308-.485.45.074,1.092-.1.3-.332L10.1.53l.6.09.219-.033A6.1,6.1,0,0,0,3.6,2.224h0ZM8.57.608,9.195.264,9.6.5,9.015.938,8.461.994,8.211.832ZM6.72.658,7,.773,7.357.658l.2.341-.833.219L6.32.983S6.711.731,6.72.658Z",
    transform: "translate(-2.197 0)",
    fill: "#c22127"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(921 549)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAny);
export default __webpack_public_path__ + "static/media/any.c9568bc32ea7ac4cc390b5187f1d6573.svg";
export { ForwardRef as ReactComponent };